import React from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, GraduationCap, Users, Heart } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function CareersPage() {
  return <div className="bg-white" data-id="element-153">
      {/* Hero */}
      <div className="bg-emerald-600 text-white py-20" data-id="element-154">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-155">
          <h1 className="text-4xl font-bold mb-6" data-id="element-156">Karriere bei Lissowski</h1>
          <p className="text-xl text-emerald-100 max-w-2xl mx-auto" data-id="element-157">
            Werde Teil unseres Teams! Wir suchen motivierte Mitarbeiter, die mit
            uns wachsen wollen.
          </p>
        </div>
      </div>

      {/* Culture */}
      <section className="py-20" data-id="element-158">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-160">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-161">
              Arbeiten bei Lissowski
            </h2>
            <p className="text-lg text-gray-600" data-id="element-162">
              Seit mehr als 50 Jahren sind wir erfolgreich tätig.
              Mitarbeiterzufriedenheit steht bei uns ganz oben - ein angenehmes
              Betriebsklima, Aufstiegschancen und Weiterbildung sind für uns
              selbstverständlich.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-20" data-id="element-163">
            <div className="text-center p-6" data-id="element-164">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-165">
                <Heart className="w-8 h-8 text-emerald-600" data-id="element-166" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-167">Familiäres Klima</h3>
              <p className="text-gray-600" data-id="element-168">
                Wertschätzung und ein gutes Miteinander prägen unseren
                Arbeitsalltag.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-169">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-170">
                <GraduationCap className="w-8 h-8 text-emerald-600" data-id="element-171" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-172">Aus- & Weiterbildung</h3>
              <p className="text-gray-600" data-id="element-173">
                Wir fördern deine Entwicklung vom Azubi bis zum Meister.
              </p>
            </div>
            <div className="text-center p-6" data-id="element-174">
              <div className="bg-emerald-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-175">
                <Users className="w-8 h-8 text-emerald-600" data-id="element-176" />
              </div>
              <h3 className="text-xl font-bold mb-2" data-id="element-177">Sicherer Arbeitsplatz</h3>
              <p className="text-gray-600" data-id="element-178">
                Als etabliertes Unternehmen bieten wir langfristige
                Perspektiven.
              </p>
            </div>
          </div>

          {/* Training / Jobs */}
          <div className="bg-gray-50 rounded-2xl p-8 md:p-12" data-id="element-179">
            <h2 className="text-2xl font-bold text-gray-900 mb-8" data-id="element-180">
              Ausbildung & Stellenangebote
            </h2>

            <div className="space-y-6" data-id="element-181">
              {[{
              title: 'Ausbildung zum Glas- und Gebäudereiniger (m/w/d)',
              type: 'Ausbildung',
              desc: 'Lerne einen vielseitigen Beruf mit Zukunft und guten Aufstiegschancen.'
            }, {
              title: 'Ausbildung Kaufmann/-frau für Büromanagement (m/w/d)',
              type: 'Ausbildung',
              desc: 'Organisationstalente gesucht! Unterstütze unser Büro-Team.'
            }, {
              title: 'Gebäudereiniger / Glasreiniger (m/w/d)',
              type: 'Vollzeit / Teilzeit',
              desc: 'Für unsere Objekte im Raum Aachen suchen wir Verstärkung.'
            }].map((job, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-182">
                  <div data-id="element-183">
                    <div className="flex items-center gap-3 mb-2" data-id="element-184">
                      <h3 className="text-lg font-bold text-gray-900" data-id="element-185">
                        {job.title}
                      </h3>
                      <span className="bg-blue-100 text-blue-800 text-xs font-bold px-2 py-1 rounded" data-id="element-186">
                        {job.type}
                      </span>
                    </div>
                    <p className="text-gray-600" data-id="element-187">{job.desc}</p>
                  </div>
                  <a href="mailto:buero@lissowski-gmbh.de?subject=Bewerbung" data-id="element-188">
                    <Button variant="outline" size="sm" data-id="element-189">
                      Jetzt bewerben
                    </Button>
                  </a>
                </div>)}
            </div>

            <div className="mt-12 text-center" data-id="element-190">
              <p className="text-gray-600 mb-4" data-id="element-191">
                Nicht das Passende dabei? Wir freuen uns auch über
                Initiativbewerbungen!
              </p>
              <a href="mailto:buero@lissowski-gmbh.de" data-id="element-192">
                <Button variant="primary" data-id="element-193">Initiativ bewerben</Button>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>;
}